export default __webpack_public_path__ + "static/image-58687e7248c5bf8a169ee3fc582ca68f.png";